
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-sand';

      document.querySelector('folk-sand').onMaterialChange = (materialNumber) => {
        document.querySelector('key-helper button[active]').removeAttribute('active');
        document.querySelector(`key-helper button:nth-child(${materialNumber})`).setAttribute('active', '');
      };
    